import Vue from "vue";
import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
  deferScriptLoad: true,
  config: { id: "G-BRH3E70VNP" },

})